import { Divider, InfoTooltip, ListCard, NetworkIcon } from '@capsicum/common-web';
import { type NCWConfirmTransferFeeCardProps, useNCWConfirmTransferFeeCard } from '@capsicum/features/nc-wallet/shared';
import styled from 'styled-components';

export const NCWConfirmTransferFeeCard = ({
	formattedConvertedFee,
	formattedFee,
	recipient
}: NCWConfirmTransferFeeCardProps) => {
	const { intlTexts, networkType, networkTypeLabel } = useNCWConfirmTransferFeeCard({ recipient });

	return (
		<S.Container testID="ncw-transfer-confirmation-feeCard">
			<S.Content>
				<S.RowContainer>
					<S.NetworkLabel>{intlTexts.network}</S.NetworkLabel>
					<S.Network>
						<NetworkIcon network={networkType} size="default" variant="default" />

						<S.NetworkText>{networkTypeLabel}</S.NetworkText>
					</S.Network>
				</S.RowContainer>
				<S.NetworkDivider orientation="horizontal" />
				<S.RowContainer>
					<S.TooltipLabel>
						{intlTexts.networkFee}
						<InfoTooltip contentPosition="bottom_right">{intlTexts.networkFeeTooltip}</InfoTooltip>
					</S.TooltipLabel>
					<S.AmountContainer>
						<S.FeeRow>{formattedFee}</S.FeeRow>
						{`≈${formattedConvertedFee}`}
					</S.AmountContainer>
				</S.RowContainer>
			</S.Content>
		</S.Container>
	);
};

namespace S {
	export const Container = styled(ListCard)`
		height: auto;
		margin-bottom: ${({ theme }) => theme.spacings.xsmall};
	`;

	export const Content = styled(ListCard.Content)`
		padding: ${({ theme }) => theme.spacings.small};
		width: 100%;
		gap: ${({ theme }) => theme.spacings.xsmall};
		display: flex;
		flex-direction: column;
		align-items: space-between;
	`;

	export const AmountContainer = styled.div`
		margin: 0;
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxxsmall};
		${({ theme }) => theme.fonts.text.text3};
		color: ${({ theme }) => theme.colors.text.main.subtle};
		justify-items: flex-end;
		text-align: end;
	`;

	export const FeeRow = styled.div`
		margin: 0;
		display: flex;
		align-items: center;
		flex-direction: row;
		gap: ${({ theme }) => theme.spacings.xxsmall};
		${({ theme }) => theme.fonts.headings.title6};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const TooltipLabel = styled.div`
		display: flex;
		gap: ${({ theme }) => theme.spacings.xxxsmall};
		align-items: center;
		${({ theme }) => theme.fonts.text.text3};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const RowContainer = styled.div`
		display: flex;
		justify-content: space-between;
		width: 100%;
	`;

	export const NetworkDivider = styled(Divider)`
		margin: ${({ theme }) => theme.spacings.xsmall} 0px;
	`;

	export const Network = styled.span`
		${({ theme }) => theme.fonts.text.text1};
		display: flex;
		gap: ${({ theme }) => theme.spacings.xxsmall};
		justify-content: center;
		align-items: center;
	`;

	export const NetworkLabel = styled.span`
		${({ theme }) => theme.fonts.text.text3};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;
	export const NetworkText = styled.span`
		${({ theme }) => theme.fonts.text.text1};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;
}
